import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Chat from "./chat/chat";
import AdminControls from "./AdminControls"; // Componente de administración
import "./App.scss";

// Función para detectar si estamos en un dispositivo iOS
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// Función para activar pantalla completa
const activateFullscreen = () => {
  const elem = document.documentElement; // Elemento raíz
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) {
    // Safari o iOS
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    // IE/Edge antiguos
    elem.msRequestFullscreen();
  } else {
    console.log("Pantalla completa no soportada.");
  }
};

// Función para pantalla completa en iOS
const enableFullscreenForIOS = () => {
  const video = document.createElement("video"); // Elemento <video> invisible
  video.style.position = "absolute";
  video.style.top = "0";
  video.style.left = "0";
  video.style.width = "0";
  video.style.height = "0";
  video.style.opacity = "0";
  video.setAttribute("playsinline", "true"); // Necesario en iOS para evitar entrar en modo teatro
  document.body.appendChild(video);
  video.play().catch(() => {
    console.log("Error al iniciar video para pantalla completa.");
  });
};

// Wake Lock API
const useWakeLock = () => {
  useEffect(() => {
    let wakeLock = null;

    const requestWakeLock = async () => {
      try {
        if ("wakeLock" in navigator) {
          wakeLock = await navigator.wakeLock.request("screen");
          console.log("Wake Lock activado.");
        } else {
          console.log("Wake Lock API no soportada en este navegador.");
        }
      } catch (err) {
        console.error("Error al activar Wake Lock:", err);
      }
    };

    const releaseWakeLock = () => {
      if (wakeLock) {
        wakeLock.release();
        console.log("Wake Lock liberado.");
      }
    };

    // Solicitar Wake Lock al montar el componente
    requestWakeLock();

    // Liberar Wake Lock al desmontar el componente
    return () => {
      releaseWakeLock();
    };
  }, []);
};

function Appmain() {
  useWakeLock(); // Activar Wake Lock
  const [chats, setChats] = useState([]);
  const [showAnfiteatro, setShowAnfiteatro] = useState(true); // Estado para mostrar/ocultar el anfiteatro

  const addMessage = (roomname) => {
    if (!chats.find((chat) => chat.roomname === roomname)) {
      setChats((state) => [...state, { roomname }]);
    }

    // Intentar activar pantalla completa según la plataforma
    if (isIOS()) {
      enableFullscreenForIOS();
    } else {
      activateFullscreen();
    }

    // Ocultar el anfiteatro si no estamos en /admin
    if (window.location.pathname !== "/admin") {
      setShowAnfiteatro(false);
    }
  };

  return (
    <React.Fragment>
      <div className="room">
        {/* Aquí se muestran las salas que se han creado */}
        {chats.map((chat, index) => (
          <div key={index}>
            <Chat roomname={chat.roomname} />
          </div>
        ))}
      </div>

      {showAnfiteatro && ( // Mostrar el anfiteatro solo si showAnfiteatro es true
        <div className="anfiteatro-container">
          {/* Logo encima del anfiteatro */}

          <a href="https://www.instagram.com/tributocoldplay_paradise/" target="_blank">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              alt="Instagram"
              className="instagram-icon"
              style={{ width: "40px", height: "40px", left: "45%", position: "relative" }}
            />
          </a>

          <div className="logo-container">
            <a href="https://www.paradisetributocoldplay.com" target="_blank" rel="noopener noreferrer">
              <img
                src="https://www.paradisetributocoldplay.com/uploads/o_1i44g2d871at218bf1nvf15d1lb4a.png"
                alt="Logo"
                className="anfiteatro-logo"
              />
            </a>
          </div>

          {/* Los botones del anfiteatro */}
          <div className="anfiteatro">
            <div className="fila-1">
              <div className="escalon">
                <button type="button" onClick={() => addMessage("Izquierda")}>
                  Lateral Izquierda
                </button>
              </div>
              <div className="escalon">
                <button type="button" onClick={() => addMessage("Centro")}>
                  Centro
                </button>
              </div>
              <div className="escalon">
                <button type="button" onClick={() => addMessage("Derecha")}>
                  Lateral Derecha
                </button>
              </div>
            </div>

            <div className="escenario">Escenario</div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Ruta para usuarios normales */}
          <Route path="/" element={<Appmain />} />

          {/* Ruta para el panel de administración */}
          <Route path="/admin" element={<AdminControls />} />

          {/* Ruta por defecto */}
          <Route component={Appmain} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
